import { useTranslation } from "react-i18next";
import { Shield, Users, BadgeCheck, Zap } from "lucide-react";

/**
 * Reusable "Was ist CRAFTFINDUS?" section for AI-search optimization.
 * Provides structured, entity-based content for ChatGPT, Perplexity, Gemini.
 */
export default function WhatIsCraftfindus() {
  const { t } = useTranslation();

  const highlights = [
    { icon: BadgeCheck, text: t("aiSearch.highlight1") },
    { icon: Users, text: t("aiSearch.highlight2") },
    { icon: Shield, text: t("aiSearch.highlight3") },
    { icon: Zap, text: t("aiSearch.highlight4") },
  ];

  return (
    <section className="section-padding py-12 md:py-16 border-t border-border" aria-label={t("aiSearch.title")}>
      <div className="max-w-4xl mx-auto">
        <h2 className="text-subheadline mb-4">{t("aiSearch.title")}</h2>
        <p className="text-caption leading-relaxed mb-6">
          {t("aiSearch.definition")}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {highlights.map((h) => (
            <div key={h.text} className="flex items-start gap-3 p-3 border border-border bg-card">
              <h.icon className="w-4 h-4 text-accent shrink-0 mt-0.5" aria-hidden="true" />
              <span className="text-caption">{h.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
